import {State, Action, Selector, StateContext} from '@ngxs/store';
import {
  GetAllUsers, GetUserStats
} from './user.actions';
import {UserService} from '@shared/service/user/user.service';
import {Injectable} from '@angular/core';
import {ServerResponse} from '@shared/interfaces';

export interface UserStateModel {
  users: any[];
  userStats: any;
}

@State<UserStateModel>({
  name: 'user',
  defaults: {
    users: [],
    userStats: {},
  }
})
@Injectable()
export class UserState {
  constructor(private userService: UserService) {
  }

  @Selector()
  static getUsers(state: UserStateModel) {
    return state.users;
  }

  @Selector()
  static getUserStats(state: UserStateModel) {
    return state.userStats;
  }

  @Action(GetAllUsers)
  getUsersData({patchState}: StateContext<UserStateModel>) {
    return this.userService.getAllUsers()
      .then((response: ServerResponse) => {
        patchState({
          users: response.data
        });
      });
  }

  @Action(GetUserStats)
  getUserStats({patchState}: StateContext<UserStateModel>) {
    return this.userService.getUserStats()
      .then((stats) => {
        patchState({
          userStats: stats
        });
      });
  }
}
